import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';

import axios from 'axios';

class ArticleHttp {
  static getArticle = async () => {
    try {
      const response = await axios.get(
        'https://cms.ebullion.in/api/articles?populate=deep&sort[id]=desc'
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching article:', error);
      throw error;
    }
  };
}

export default ArticleHttp;
